import type { RouteConfig } from "@/types/routestypes";
import { lazy } from "react";

const Role = lazy(() => import("@/pages/Roles/Roles"));
const RoleList = lazy(() => import("@/pages/Roles/RoleList/RoleList"));
const RolePermission = lazy(() => import("@/pages/Roles/RolePermission/RolePermission"));

const RoleRoutes: RouteConfig = {
    path: "roles",
    element: <Role />,
    pageName: "Roles",
    sidebar: { show: true, icon: "" },
    permission: ["ManageRoles"],
    children: {
        MAIN: {
            path: "",
            pageName: "Roles",
            element: <RoleList />,
            sidebar: { show: false, icon: "" },
        },
        ROLE_PERMISSIONS: {
            path: "permission/:id",
            pageName: "Roles",
            element: <RolePermission />,
            sidebar: { show: false },
        }
    }
}

export default RoleRoutes;